

























import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model, Watch} from "vue-property-decorator";

@Component({
  name: "InputDateCustom"
})
export default class extends mixins(CommonMixin) {
  @Model("change", { type: String }) readonly inputDate!: string;
  @Emit('change')
  onChangeInputDate(val: any) {
    return val;
  }
  day = '' as any;
  month = '' as any;
  year = '' as any;

  created() {
    const dateCustom = this.inputDate.split('/');
      this.day = dateCustom[0] || '';
    this.month = dateCustom[1] || '';
    this.year = dateCustom[2] || '';
  }
  
  @Watch('inputDate')
  onChangeInput(val: any) {
      const dateCustom = this.inputDate.split('/');
      this.day = dateCustom[0] || '';
      this.month = dateCustom[1] || '';
      this.year = dateCustom[2] || '';
  }
  

  onKeyUpDay(evt: any) {
    let val = evt.target.value;
    if (!val) return;
    if (isNaN(val)) val = '01';
    if (val > 31) val = '01';
    this.day = val;
    const inputDate = `${val ? val : '2020'}/${this.month ? this.month : '01'}/${this.year ? this.year : '2020'}`
    this.onChangeInputDate(inputDate);
    if (evt.which == 9) return;
    if (val.length >= 2) (this.$refs.inputMonth as any).focus();
  }

  onKeyUpMonth(evt: any) {
    let val = evt.target.value;
    if (!val) return;
    if (isNaN(val)) val = '01';
    if (val > 12) val = '12';
    this.month = val;
    const inputDate = `${this.day ? this.day : '01'}/${val ? val : '01'}/${this.year ? this.year : '2020'}`
    this.onChangeInputDate(inputDate);
    if (evt.which == 9) return;
    if (val.length >= 2) (this.$refs.inputYear as any).focus();
  }

  onKeyUpYear(evt: any) {
    let val = evt.target.value;
    if (!val) return;
    if (isNaN(val)) val = '2020';
    this.year = val;
    const inputDate = `${this.day ? this.day : '01'}/${this.month ? this.month : '01'}/${val ? val : '2020'}`
    this.onChangeInputDate(inputDate);
  }
}
